import { fetchFromApi, optionsForPostRequest } from './apiUtils';

const basePath = '/v1/message';

const createMessage = data =>
  fetchFromApi(basePath, optionsForPostRequest(data));

export default { createMessage };
